import React from "react";
import PropTypes from "prop-types";
import { AnchorTag } from "./AnchorTag";

const AnchorTagConnector = ({ data }) => <AnchorTag id={data.id} />;

AnchorTagConnector.propTypes = {
	data: PropTypes.shape({
		id: PropTypes.string,
	}).isRequired,
};

export { AnchorTagConnector };
